import { useActivitySummaryContext } from '@user/features/Activity/ActivitySummary/context'
import { closeEditActivityActionCreator } from '@user/features/Activity/ActivitySummary/state'
import { useRefreshActivitySummaryTable } from '@user/features/Activity/hooks/useRefreshActivitySummaryTable'
import { useCallback } from 'react'

export function useHandlers() {
  const [{ open }, dispatch] = useActivitySummaryContext()

  const { refetch } = useRefreshActivitySummaryTable()

  const onClose = useCallback(
    () => dispatch(closeEditActivityActionCreator()),
    [dispatch],
  )

  const onSave = useCallback(() => {
    refetch()
  }, [refetch])

  return {
    open,
    onClose,
    onSave,
  }
}
